import { render, staticRenderFns } from "./answers.vue?vue&type=template&id=0717602d"
import script from "./answers.vue?vue&type=script&lang=js"
export * from "./answers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports